const { throwError, getExperiment, getGoal } = require('./ab-helpers');
const abTypes = require('./ab-types');

const OPENTABLE_UNIQUE_VISITOR_ID = 'otuvid';

const abClient = (abPlatform, abVariantCalculator, abAnalytics, cookies) => {
  if (!cookies) {
    throwError('[abClient] cookies parameter required');
  }

  let initialised = false;
  let experimentSummaries = null;
  const init = (options, callback) => {
    if (initialised) {
      callback({ type: abTypes.CLIENT_INITIALISED });
    } else {
      abPlatform.fetchExperimentSummaries(options, message => {
        if (message.type === abTypes.EXPERIMENT_SUMMARIES_ERROR) {
          callback(message);
        } else {
          experimentSummaries = message.payload;
          initialised = true;
          callback({ type: abTypes.CLIENT_INITIALISED });
        }
      });
    }
  };

  const getVariant = (options, callback) => {
    const experiment = getExperiment(
      experimentSummaries,
      options.experimentName
    );
    if (!experiment) {
      throwError(`${abTypes.EXPERIMENT_NOT_FOUND} ${options.experimentName}`);
    }
    experiment.uniqueVisitorId = cookies.get(OPENTABLE_UNIQUE_VISITOR_ID);
    abVariantCalculator.calculateVariant(
      { experiment, url: options.url },
      message => {
        callback(message);
      }
    );
  };

  const trackExperiment = (options, callback) => {
    const experiment = getExperiment(
      experimentSummaries,
      options.experimentName
    );
    if (!experiment) {
      throwError(`${abTypes.EXPERIMENT_NOT_FOUND} ${options.experimentName}`);
    } else if (experiment.stage.toUpperCase() !== 'RUNNING') {
      callback({ type: abTypes.EXPERIMENT_NOT_RUNNING });
    } else {
      const copy = Object.assign({}, options);
      copy.experimentNumber = experiment.number;
      abAnalytics.trackExperiment(copy, callback);
    }
  };

  const trackGoal = (options, callback) => {
    const goal = getGoal(experimentSummaries, options.goalName);
    if (!goal) {
      throwError(`${abTypes.GOAL_NOT_FOUND} ${options.goalName}`);
    }
    abAnalytics.trackGoal(options, callback);
  };

  return {
    init,
    getVariant,
    messageTypes: abTypes,
    trackExperiment,
    trackGoal
  };
};

module.exports = abClient;



// WEBPACK FOOTER //
// ./src/ab-client.js